<template>
  <div>
    <Table
      border
      :loading="tableLoading"
      :columns="filteredCol"
      :data="tableData"
      @on-sort-change="sortTable"
      :height="tableHeight"
    >
      <!-- 客户名 -->
      <template slot-scope="{ row }" slot="customer">
        <Poptip title="权责表" trigger="hover" placement="right" transfer>
          {{ row.customer.name }}
          <template #content>
            <div class="content-item">
              <div>开发：</div>
              <div>{{row.customer.comissionDivDev.map(x=> {
                return x.user.name + (x.ratio*100).toFixed(0) + "%"
              }).join('、')}}</div>
            </div>
            <div class="content-item">
              <div>维护：</div>  
              <div>{{row.customer.comissionDivMaintain.map(x=> {
                return x.user.name + (x.ratio*100).toFixed(0) + "%"
              }).join('、')}}</div>
            </div>
            <div class="content-item">
              <div>回款：</div>  
              <div>{{row.customer.comissionDivPayment.map(x=> {
                return x.user.name + (x.ratio*100).toFixed(0) + "%"
              }).join('、')}}</div>
            </div>
          </template>
        </Poptip>
      </template>
      <!-- 金蝶云 -->
      <template slot-scope="{ row }" slot="JDItemCode">
        <!-- <div v-if="JDIndexFile !== row._id" @click="show(row, 'JD')">
          {{ row.JDItemCode ? row.JDItemCode : "-" }}
        </div> -->
        <div>
          {{ row.JDItemCode ? row.JDItemCode : "-" }}
        </div>
      </template>
      <!-- 售价 -->
      <template slot-scope="{ row }" slot="price">
        <div>
          {{
            row.calcSalesCost
              ? adjustNumber(row, "calcSalesCost.price")
              : row.price
              ? row.price.price
              : "-"
          }}
        </div>
        <!-- <div v-show="priceFile === row._id">
          <Input autofocus @on-blur="setPrice(row)" v-model="editPrice" />
        </div> -->
      </template>
      <!-- 运费 -->
      <template slot-scope="{ row }" slot="transPrice">
        <div>
          {{
            row.calcSalesCost
              ? adjustNumber(row, "calcSalesCost.transCost")
              : row.transCost
              ? row.transCost.cost
              : "-"
          }}
        </div>
        <!-- <div v-show="transPriceFile === row._id">
          <Input
            autofocus
            @on-blur="setTransCost(row)"
            v-model="editTransPrice"
          />
        </div> -->
      </template>
      <!-- 业务费 -->
      <template slot-scope="{ row }" slot="promoFee">
        <div>
          {{
            row.calcSalesCost
              ? adjustNumber(row, "calcSalesCost.promoFee")
              : row.promoFeeSum
              ? row.promoFeeSum
              : "-"
          }}
        </div>
        <!-- <div v-show="promoFeeFile === row._id">
          <Input
            @on-blur="setPromoFee(row)"
            v-model="editPromoFee"
            :ref="'file' + row._id"
          />
        </div> -->
      </template>

      <template slot-scope="{ row }" slot="review">
        <div style="display: flex; justify-content: center;" @click="openReviewDrawer(row)">
          <TextWithCornerIcon text="审核" :type="row.allowSales ? 'ok' : 'wrong'"/>

          <div v-if="row.prePaidOnly">
             - 预付
          </div>

          <div v-if="row.isLimitVolPerMonth">
             - 月限{{ row.limitVolPerMonth }}吨
          </div>
          
        </div>
        
      </template>

      <template slot-scope="{ row }" slot="operate">
        <div
          style="
            display: flex;
            justify-content: space-around;
            align-items: center;
          "
        >
          <Button
            type="default"
            size="small"
            @click="openCreateSalesDrawer(row)"
            >项目</Button
          >
          <Button type="default" size="small" @click="openSaleDrawer(row)"
            >销售</Button
          >
          <Dropdown trigger="hover" @on-click="clickActionDropDown" transfer>
            <a>
              更多
              <Icon type="ios-arrow-down"></Icon>
            </a>
            <DropdownMenu slot="list">
              <div>
                <DropdownItem :name="`recipe ${row._id}`">
                  配方
                </DropdownItem>
                <DropdownItem :name="`history ${row._id}`">
                  历史
                </DropdownItem>
                <DropdownItem divided :name="`supplying ${row._id}`">{{
                  row.isSupplying ? "停止供货" : "供货"
                }}</DropdownItem>
              </div>
            </DropdownMenu>
          </Dropdown>
        </div>
      </template>
      
    
    </Table>
    <CreateSalesDrawer ref="CreateSalesDrawer" />
    <SalesCostDrawer ref="SalesCostDrawer" />
    <CalcSalesDetailDrawer ref="CalcSalesDetailDrawer" />
    <RecipeDrawer ref="RecipeDrawer" />
    <ReviewDrawer ref="ReviewDrawer" />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import dayjs from "dayjs";
import _ from "lodash";
import TextWithCornerIcon from "@/components/TextWithCornerIcon.vue";
import CalcSalesDetailDrawer from "./CalcSalesDetailDrawer";
import RecipeDrawer from "../SalesPage/RecipeDrawer.vue";
import SalesCostDrawer from "./SalesCostDrawer";
import CreateSalesDrawer from "../SalesPage/CreateSalesDrawer.vue";
import ReviewDrawer from "./ReviewDrawer.vue";
import { arrayIntersection } from "@/utils";



export default {
  props: ["tableLoading", "tableHeight", "hideColumn"],
  name: "CalcCostTable",
  components: {
    SalesCostDrawer,
    CalcSalesDetailDrawer,
    CreateSalesDrawer,
    RecipeDrawer,
    ReviewDrawer,
    TextWithCornerIcon
  },
  data() {
    return {
      columns: [
        {
          title: "简称",
          key: "abbr",
          minWidth: 150,
          maxWidth: 650,
          fixed: "left",
          render: (h, params) => {
            return h(
              "div",
              {
                style: {
                  color: params.row.isSupplying ? "#42b983" : "#FE7708",
                  cursor: "pointer",
                },
                on: {
                  click: () => {
                    if (params.row.calcSalesCost) {
                      this.$refs.CalcSalesDetailDrawer.openDrawer(params.row);
                    } else {
                      this.$Message.error("该项目没有核算");
                    }
                  },
                },
              },
              params.row.abbr
            );
          },
        },
        {
          title: "客户",
          key: "customer",
          slot: "customer",
          minWidth: 250,
          maxWidth: 600,
        },
        {
          title: "材料",
          key: "material",
          align: "left",
          width: 80,
          render: (h, params) => {
            return h("div", params.row.material.model);
          },
        },
        {
          title: "配方",
          key: "recipe",
          align: "left",
          width: 80,
          render: (h, params) => {
            return h("div", this.adjustRecipe(params.row));
          },
        },
        // {
        //   title: "核算配方",
        //   key: "recipe",
        //   align: "center",
        //   minWidth: 80,
        //   render: (h, params) => {
        //     return h(
        //       "div",
        //       params.row.calcSalesCost
        //         ? "#" + params.row.calcSalesCost.recipe.NoId
        //         : ""
        //     );
        //   },
        // },
        {
          title: "金蝶云",
          key: "JDItemCode",
          slot: "JDItemCode",
          align: "left",
          minWidth: 80,
        },
        {
          title: "材料成本",
          key: "materialCost",
          align: "right",
          sortable: "custom",
          minWidth: 100,
          render: (h, params) => {
            return h(
              "div",
              params.row.calcSalesCost
                ? parseInt(params.row.calcSalesCost.materialCost)
                : ""
            );
          },
        },
        {
          title: "运输费",
          key: "transPrice",
          slot: "transPrice",
          sortable: "custom",
          align: "right",
          minWidth: 80,
        },
        {
          title: "业务费",
          key: "promoFee",
          slot: "promoFee",
          sortable: "custom",
          align: "right",
          minWidth: 80,
        },
        {
          title: "复配费",
          key: "manufactCost",
          sortable: "custom",
          align: "right",
          minWidth: 80,
          render: (h, params) => {
            return h(
              "div",
              params.row.calcSalesCost
                ? params.row.calcSalesCost.manufactCost
                  ? parseInt(params.row.calcSalesCost.manufactCost)
                  : ""
                : ""
            );
          },
        },
        {
          title: "税费",
          key: "tax",
          sortable: "custom",
          align: "right",
          minWidth: 80,
          render: (h, params) => {
            return h(
              "div",
              params.row.calcSalesCost
                ? params.row.calcSalesCost.tax
                  ? parseInt(params.row.calcSalesCost.tax)
                  : ""
                : ""
            );
          },
        },
        {
          title: "合计成本",
          key: "agingCost",
          align: "right",
          minWidth: 80,
          render: (h, params) => {
            return h(
              "div",
              this.adjustNumber(params.row, "calcSalesCost.totalCost")
            );
          },
        },
        {
          title: "售价",
          key: "salesPrice",
          slot: "price",
          sortable: "custom",
          align: "right",
          minWidth: 80,
        },
        {
          title: "利润",
          key: "profit",
          sortable: "custom",
          align: "right",
          minWidth: 80,
          render: (h, params) => {
            return h(
              "div",
              params.row.calcSalesCost
                ? params.row.calcSalesCost.profit
                  ? parseInt(params.row.calcSalesCost.profit)
                  : ""
                : ""
            );
          },
        },
        {
          title: "利润率",
          key: "profitability",
          align: "right",
          sortable: "custom",
          minWidth: 80,
          render: (h, params) => {
            return h(
              "div",
              params.row.calcSalesCost
                ? params.row.calcSalesCost.profitRate
                  ? (params.row.calcSalesCost.profitRate * 100).toFixed(2) + "%"
                  : ""
                : ""
            );
          },
        },
        {
          title: "销量",
          key: "salesVol",
          align: "right",
          minWidth: 100,
          render: (h, params) => {
            return h("div", params.row.salesVol?.map(v => v.toFixed(0)).join('-'));
          },
        },
        {
          title: "账期",
          key: "estAging",
          sortable: "custom",
          align: "right",
          minWidth: 80,
          render: (h, params) => {
            return h("div", params.row.estAging ? params.row.estAging : "");
          },
        },
        {
          title: "资金成本",
          key: "agingCost",
          sortable: "custom",
          align: "right",
          minWidth: 100,
          render: (h, params) => {
            return h(
              "div",
              params.row.calcSalesCost
                ? params.row.calcSalesCost.agingCost
                  ? parseInt(params.row.calcSalesCost.agingCost)
                  : ""
                : ""
            );
          },
        },
        {
          title: "资后成本",
          key: "totalCostWithAging",
          sortable: "custom",
          align: "right",
          minWidth: 100,
          render: (h, params) => {
            return h(
              "div",
              params.row.calcSalesCost
                ? params.row.calcSalesCost.totalCostWithAging
                  ? parseInt(params.row.calcSalesCost.totalCostWithAging)
                  : ""
                : ""
            );
          },
        },
        {
          title: "资后利润",
          key: "profitAfterAging",
          sortable: "custom",
          align: "right",
          minWidth: 100,
          render: (h, params) => {
            return h(
              "div",
              params.row.calcSalesCost
                ? params.row.calcSalesCost.profitAfterAging
                  ? parseInt(params.row.calcSalesCost.profitAfterAging)
                  : ""
                : ""
            );
          },
        },
        {
          title: "资利润率",
          key: "profitRateAfterAging",
          align: "right",
          sortable: "custom",
          minWidth: 100,
          render: (h, params) => {
            return h(
              "div",
              params.row.calcSalesCost
                ? params.row.calcSalesCost.profitRateAfterAging
                  ? (
                      params.row.calcSalesCost.profitRateAfterAging * 100
                    ).toFixed(2) + "%"
                  : ""
                : ""
            );
          },
        },
        {
          title: "年收益率",
          key: "annualizedRateOfReturns",
          sortable: "custom",
          align: "right",
          minWidth: 100,
          render: (h, params) => {
            return h(
              "div",
              params.row.calcSalesCost
                ? params.row.calcSalesCost.annualizedRateOfReturns
                  ? (
                      params.row.calcSalesCost.annualizedRateOfReturns * 100
                    ).toFixed(2) + "%"
                  : ""
                : ""
            );
          },
        },

        {
          title: "核算日期",
          key: "createdAt",
          align: "center",
          width: 150,
          render: (h, params) => {
            return h(
              "div",
              params.row.calcSalesCost
                ? dayjs(params.row.calcSalesCost.createdAt).format(
                    "YYYY-MM-DD HH:mm"
                  )
                : ""
            );
          },
        },

        {
          title: "成本计算",
          key: "caclCost",
          align: "center",
          width: 100,
          render: (h, params) => {
            return h("div", [
              h(
                "h4",
                {
                  style: {
                    color: "#2D8CF0",
                    cursor: "pointer",
                    borderRadius: "4px",
                    border: "1px solid #2D8CF0",
                  },
                  on: {
                    click: () => {
                      this.caclOneSalesCost(params.row._id);
                    },
                  },
                },
                "成本计算"
              ),
            ]);
          },
        },
        // {
        //   title: "审核",
        //   key: "review",
        //   slot: "review",
        //   align: "center",
        //   fixed: "right",
        //   width: 180,
        // },
        {
          title: "操作",
          key: "operate",
          slot: "operate",
          align: "center",
          fixed: "right",
          width: 180,
        },
      ],
    };
  },
  computed: {
    ...mapState({
      tableData: (state) => state.caclSalesCost.salesLatestCost,
      totalCounts: (state) => state.caclSalesCost.totalCounts,
      user: (state) => state.auth.currentUser,
    }),
    filteredCol() {
      if (!this.hideColumn) return this.columns;
      return this.columns.filter(v => !this.hideColumn.includes(v.title));
    }
  },
  methods: {
    ...mapActions({
      updateSales: "sales/updateSalesAction",
      calcSalesCostById: "caclSalesCost/calcSalesCostByIdAction",
    }),
    arrayIntersection(array, targetArray) {
      return arrayIntersection(array, targetArray);
    },
    // 数值转换
    adjustNumber(params, numberString, appendString) {
      const value = _.get(params, numberString, "");
      if (typeof value === "number") {
        return appendString
          ? value.toFixed(0) + appendString
          : value.toFixed(0);
      } else if (typeof value === "string") {
        return 0;
      }
    },
    adjustRecipe(params) {
      if (params.calcSalesCost) {
        return params.calcSalesCost.recipe.NoId === params.prodRecipe.NoId
          ? "#" + params.calcSalesCost.recipe.NoId
          : "产#" +
              params.prodRecipe.NoId +
              "\n" +
              "算#" +
              params.calcSalesCost.recipe.NoId;
      } else if (params.prodRecipe) {
        return "产#" + params.prodRecipe.NoId;
      }
      // const value = _.get(params, numberString, "");
    },
    // 单个成本核算
    async caclOneSalesCost(sales) {
      try {
        await this.calcSalesCostById({
          sales,
        });
        this.$Message.success("计算完成");
      } catch (error) {
        this.$Message.error({
          content: "计算失败，" + error,
          closable: true,
          duration: 0,
        });
      }
    },
    // 打开审核Drawer
    openReviewDrawer(sales) {
      const user = this.user
      if (user.superAdmin || this.arrayIntersection(['salesLead'], user.simpleRole).length > 0) {
        this.$refs.ReviewDrawer.openDrawer(sales);
      }
    },
    // 操作列表
    async clickActionDropDown(name) {
      const actionCode = name.split(" ")[0];
      const id = name.split(" ")[1];
      const currentSales = this.tableData.find((x) => x._id === id);

      switch (actionCode) {
        case "supplying":
          const data = {};
          if (currentSales.isSupplying) {
            data.isSupplying = false;
          } else {
            data.isSupplying = true;
          }
          await this.updateSales({ id: currentSales._id, data });
          this.$emit("loadSalesCost");
          break;
      }
    },
    openCreateSalesDrawer(row) {
      this.$refs.CreateSalesDrawer.openDrawer(row);
    },
    openRecipeDrawer(sales) {
      this.$refs.RecipeDrawer.openDrawer(sales, true);
    },
    // 操作列表
    async clickActionDropDown(name) {
      const actionCode = name.split(" ")[0];
      const id = name.split(" ")[1];
      const currentSales = this.tableData.find((x) => x._id === id);

      switch (actionCode) {
        case "supplying":
          const data = {};
          if (currentSales.isSupplying) {
            data.isSupplying = false;
          } else {
            data.isSupplying = true;
          }
          await this.updateSales({ id: currentSales._id, data });
          this.$emit("loadSalesCost");
          break;
        case "recipe":
          this.openRecipeDrawer(currentSales);
          break;
        case "history":
          this.openAnalyzeDrawer(currentSales);
          break;
      }
    },
    openSaleDrawer(sales) {
      this.$refs.SalesCostDrawer.openDrawer(sales);
    },
    // 历史分析
    openAnalyzeDrawer(sales) {
      this.$router.push({
        path: "/home/caclSalesCostAnalyze",
        query: {
          id: sales._id,
          customer: sales.customer.name,
          abbr: sales.abbr,
        },
      });
    },
    // 排序
    sortTable(data) {
      this.$emit("sortTable", data);
    },
  },
};
</script>

<style lang="stylus" scoped>
.content-item
  display flex
  margin 8px 0
  align-items center
</style>